const riot = require('riot');

riot.tag2('module-view-table', '<div class="f fclm s-full"> <div class="px16 mb10" data-is="module-note-filter" ref="filter" users="{projectUsers}" columns="{columns}"></div> <div class="s-full box-shadow-primary rounded-4 px16 pb8 overflow-scroll"> <div class="s-full bg-white overflow-scroll pt16 px16 rounded-12"> <div class="f fm"> <div class="f fm border rounded-6 py3 px6 mr16 mr0-last {getButtonClass(button)}" each="{button in buttons}" onclick="{button.event}"><i class="fs16 mr1 icon-{button.icon}"></i> <div class="fs12">{button.label}</div> </div> </div> <table class="w-full border-spacing-0 border-collapse-collapse"> <tr class="h40 text-left border-bottom text-label_dark_medium fs12 word-break-keep"> <th class="w40"> <label class="p8" onclick="{stopPropagation}"> <input class="s16" type="checkbox" onchange="{toggleCheckAll}" checked="{isCheckedSome()}"> </label> </th> <th class="min-width-120 px16">タイトル</th> <th class="min-width-100 w120 text-center">カラム</th> <th class="min-width-100 w120 text-center">アサイン</th> <th class="min-width-100 w120 text-center">期限</th> </tr> <tr class="h40 border-bottom cursor-pointer hover-trigger hover-bg-dark" each="{note in getNotes()}" onclick="{onSelectNote}"> <td class="w40"> <label class="p8" onclick="{stopPropagation}"> <input class="s16" ref="checkbox" type="checkbox" data-note-id="{note.id}"> </label> </td> <td class="px16"> <div class="lh15 word-break-all line-clamp-1">{note.data.title || \'(untitled)\'}</div> </td> <td class="px16"> <div class="inline-block" data-is="atom-status" note="{note}" enable-next="{true}"></div> </td> <td class="px16"> <div class="inline-block" data-is="atom-assign" note="{note}"></div> </td> <td class="px16 font-lato"> <div class="f fm" onclick="{onOpenScheduleModal}"><i class="icon-time pt2 fs16 text-label_dark_medium mr4 tooltip" aria-label="期限を設定" data-tooltip-position="top"></i> <div class="f fh {note.getTermColor()}" if="{note.data.end_at}">{dayjs(note.data.end_at).format(\'YYYY/MM/DD\')}</div> </div> </td> </tr> </table> </div> </div> </div>', 'module-view-table,[data-is="module-view-table"]{display:block}', '', function(opts) {
    this.buttons = [
      {label: 'カラムを変更', icon: 'change' , event: (e) => this.onColumnChangeClick(e)},
      {label: 'ノートを移動', icon: 'move' , event: () => this.onOpenNoteMoveModal()},
      {label: 'ノートを複製', icon: 'template' , event: () => this.cloneCheckedNotes()},
      {label: 'ノートを削除', icon: 'stash_box' , event: () => this.deleteCheckedNotes(), alert: true},
    ];

    this.on('mount', () => {
      this.refs.filter.on('filterchange', () => {

        app.utils.replaceLocationParams({
          q: this.refs.filter.getQueryValue().trim(),
        });

        this.watchNotes();
      });
    });

    this.on('unmount', () => {
      this.unwatchNotes();
    });

    this.setup = async ({inbox_id}, {req, res, cached}) => {

      app.shortcut.setView('table', { viewTag: this });
      let project = app.store.project;
      if (this.project === project) return ;
      this.update({
        project,
      });

      this.watchNotes();

      this.projectUsers = await this.project.fetchProjectUsers();
      this.update();

      this.columns = await this.project.fetchColumns();
      this.update();

      if (req.query.q) {
        this.refs.filter.setQueryValue(decodeURIComponent(req.query.q));
      }
    };

    this.watchNotes = () => {
      if (!this.project) return ;

      this.unwatchNotes();

      this.notesStore = this.project.collection('notes')
        .where('disabled', '==', false)
        .where('archived', '==', false)
        .orderBy('pinned', 'desc')
        .orderBy('last_commented_at', 'desc')
        .limit(128);

      let query = this.refs.filter.getQuery();
      if (query.options.column_id) {
        let column = this.project.collection('columns').doc(query.options.column_id);
        this.notesStore.where('column_ref', '==', column.ref);
      }

      this.notesStore.on('snapshot', () => {
        this.update();

        this.notesStore.items.forEach(async item => {
          await item.relate();
          app.utils.debouncedUpdate();
        });
      }).watch();
    }

    this.unwatchNotes = () => {

      if (this.notesStore) {
        this.notesStore.unwatch();
        this.notesStore.removeAllListeners();
        delete this.notesStore;
      }
    };

    this.selectNote = async (note) => {
      let modal;
      if (app.useragent.isMobile) {
        spat.router.push(`/${note.path}`);
      }
      else {
        modal = spat.modal.open('modal-note', {
          note,
        });
      }

      await modal.waitClose();

    };

    this.onSelectNote = (e) => {
      this.selectNote(e.item.note);
    };

    this.stopPropagation = (e) => {
      e.stopPropagation();
    };

    this.getNotes = () => {
      return app.utils.filterNotes(this.notesStore.items, this.refs.filter.getQuery());
    };

    this.getCheckedNotes = () => {

      let checkboxes = this.getCheckboxElements();
      let checked_note_ids = checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.dataset.noteId);

      if (checked_note_ids.length <= 0) {
        return [];
      }

      let notes = this.notesStore.items.filter(note => {
        return checked_note_ids.find(id => id === note.id);
      });

      return notes;
    };

    this.getCheckboxElements = () => {
      let checkboxes = Array.isArray(this.refs.checkbox) ? this.refs.checkbox : [this.refs.checkbox];
      return checkboxes;
    };

    this.onOpenNoteMoveModal = () => {
      let notes = this.getCheckedNotes();
      spat.modal.open('modal-note-move', {notes});
    };

    this.onColumnChangeClick = async (e) => {
      let notes = this.getCheckedNotes();
      const popup = spat.popup.open('popup-status', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        position: 'bottom',
        align: { x: 'left' },
        opts: {
          note: notes[0],
          disableAutoChange: true,
        },
      });
      const column = await popup.waitClose();
      if (column) {
        const indicator = spat.modal.indicator();
        try {

          await this.project.changeNotesColumn({
            note_ids: notes.map(note => note.id),
            next_column_id: column.id,
          });

          let checkboxes = this.getCheckboxElements();
          checkboxes.forEach(item => {
            item.checked = false;
          });
          this.update();
        }
        finally {
          indicator.close();
        }
      }
    };

    this.deleteCheckedNotes = async () => {
      let result = await spat.modal.confirm('ノートを完全に削除しますか？\nこの操作を行うと元に戻せません。', '', {
        positive: '削除',
      });
      if (!result) return;
      let notes = this.getCheckedNotes();
      let promises = notes.map(note => note.delete());
      notes = await Promise.all(promises);
      spat.toast.message('ノートを削除しました。', {icon:'stash_box'});
    };

    this.cloneCheckedNotes = async () => {
      let notes = this.getCheckedNotes();
      if (notes.length === 0) return;

      let promises = notes.map(note => note.clone());
      await Promise.all(promises);
      spat.toast.message('ノートを複製しました。', {icon:'stash_box'});
    };

    this.isCheckedSome = () => {
      let checkboxes = this.getCheckboxElements();
      let is_checked = checkboxes.some(item => item.checked);

      return is_checked;
    };

    this.toggleCheckAll = () => {
      let is_checked = this.isCheckedSome();

      let checkboxes = this.getCheckboxElements();
      checkboxes.forEach(item => {
        item.checked = !is_checked;
      });
    };

    this.focusNoteFilter = () => {
      this.refs.filter.focus();
    };

    this.clickAssignedCheckbox = () => {
      this.refs.filter.clickAssignedCheckbox();
    };

    this.getButtonClass = (button) => {
      if (!this.isCheckedSome()) {
        return "text-label_dark_disabled pointer-none";
      }
      else {
        if (button.alert) {
          return "text-alert_primary border-alert_primary cursor-pointer";
        }
        return "text-label_dark_medium cursor-pointer";
      }
    };

    this.onOpenScheduleModal = async (e) => {
      e.stopPropagation();

      let modal = spat.modal.open('modal-calendar', {note: e.item.note});
      await modal.waitClose();
      await e.item.note.refresh();
      this.update();
    };
});